const initialState = {
  eventList: [],
  filters: {
    page_no: 1,
    page_size: 10,
  },
  totalPages: 1,
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'ADMIN_REQUESTED_EVENT_LIST:EVENT_LIST:SET':
    return {
      ...state,
      eventList: data?.data,
      totalPages: data?.totalPages,
    };
  case 'ADMIN_REQUESTED_EVENT_LIST:FILTERS:SET':
    return {
      ...state,
      filters: data,
    };
  default:
    return state;
  }
};